package com.merkost.handpass.admin.di

import com.merkost.handpass.admin.container.CommandPaletteContainer
import com.merkost.handpass.admin.container.FeatureFlagsContainer
import com.merkost.handpass.admin.container.ImagesContainer
import com.merkost.handpass.admin.container.ListingDetailContainer
import com.merkost.handpass.admin.container.ListingsContainer
import com.merkost.handpass.admin.container.LogContainer
import com.merkost.handpass.admin.container.QueueContainer
import com.merkost.handpass.admin.container.PartnerListingsContainer
import com.merkost.handpass.admin.container.SidebarContainer
import com.merkost.handpass.admin.container.StatsContainer
import com.merkost.handpass.admin.container.ToastHostContainer
import com.merkost.handpass.admin.container.UserDetailContainer
import com.merkost.handpass.admin.container.UsersContainer
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val containerModule = module {
    singleOf(::ToastHostContainer)
    singleOf(::SidebarContainer)
    singleOf(::StatsContainer)
    singleOf(::FeatureFlagsContainer)
    singleOf(::ImagesContainer)
    singleOf(::LogContainer)
    singleOf(::UsersContainer)
    singleOf(::UserDetailContainer)
    singleOf(::ListingsContainer)
    singleOf(::ListingDetailContainer)
    singleOf(::QueueContainer)
    singleOf(::PartnerListingsContainer)
    singleOf(::CommandPaletteContainer)
}
